<template>
  <b-modal
    id="modalSystemAnalyticsPage"
    v-model="isOpen"
    title="Configurações de Página"
    hide-header-close
    centered
    ok-title="Salvar"
    cancel-title="Fechar"
    no-close-on-backdrop
    @hide="onHide"
    @hidden="onHide"
    @ok="handleOk"
    @cancel="onClose"
  >
    <b-row class="align-items-center">
      <b-col md="12">
        <i2-form-vue-select
          v-model="settings.type"
          :options="typesAvailable"
          label="Tipo"
          name="type"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-textarea
          v-if="checkTypeText"
          id="settings-content"
          v-model="settings.content"
          name="settings-content"
          label="Conteúdo"
          type="textarea"
          :rules="checkTypeText ? 'required' : ''"
        />
        <span v-if="checkTypeFile">
          <i2-form-input-file
            id="settings-content"
            v-model="settings.content"
            name="settings-content"
            label="Arquivo"
            :rules="checkTypeFile ? 'required' : ''"
          />
          <small v-if="urlImage"><a :href="urlImage" target="_blank">Ver imagem</a></small>
        </span>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

import I2FormInputFile from '@/components/i2/forms/elements/I2FormInputFile.vue'

export default {
  name: 'SystemAnalyticsPage',
  components: {
    I2FormInputFile,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      errorMessage: '',
      urlImage: '',
      settings: {
        type: null,
        content: '',
      },
      typesAvailable: [
        {
          value: 'content',
          text: 'Texto',
        },
        {
          value: 'youtube',
          text: 'YouTube',
        },
        {
          value: 'image',
          text: 'Imagem',
        },
      ],
    }
  },
  computed: {
    checkTypeText() {
      return this.settings.type?.value === 'content' || this.settings.type?.value === 'youtube'
    },
    checkTypeFile() {
      return this.settings.type?.value === 'image'
    },
  },
  watch: {
    open(value) {
      this.isOpen = value
      if (value) {
        this.getData()
      }
    },
  },
  methods: {
    getData() {
      this.$http.get('system-settings/page-analytics').then(
        response => {
          if (response.settings !== null) {
            this.settings.type = this.typesAvailable.find(type => type.value === response.settings.type)
            this.settings.content = response.settings.content
            if (response.settings.type === 'image' && response.settings.content.startsWith('http')) {
              this.urlImage = response.settings.content
            }
          }
        },
      )
    },
    handleOk(bvModal) {
      bvModal.preventDefault()
      let withError = false
      for (let prop in this.settings) {
        if (this.settings[prop] === '') {
          withError = true
        }
      }

      if (withError) {
        this.$notify.error('Todos os campos são de preenchimento obrigatório.')
        return false
      }
      this.save()
      return true
    },
    async save() {
      const formData = new FormData()
      formData.append('type', this.settings.type.value)
      formData.append('content', this.settings.content)
      await this.$http.post('system-settings/page-analytics', formData)
      this.$notify.success('Configuração de página salva com sucesso.')
      await this.getData()
    },
    onClose() {
      this.errorMessage = ''
      this.$emit('onClose', true)
    },
    onHide() {
      return false
    },
  },
}
</script>

<style scoped>

</style>
